import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreateUser, CreateUserResponse, UpdateUser, User } from '../types/user.type';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserClient {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiBaseUrl}/api/users`;

  deactivate(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/deactivate`, { id: id });
  }

  getAll(): Observable<User[]> {
    return this.http.get<User[]>(this.apiUrl).pipe(map((response) => response));
  }

  post(body: CreateUser): Observable<CreateUserResponse> {
    return this.http.post<CreateUserResponse>(`${this.apiUrl}`, body);
  }

  patch(body: UpdateUser): Observable<User> {
    return this.http.patch<User>(`${this.apiUrl}/update`, body);
  }

  reactivate(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/reactivate`, { id: id });
  }

  revokeAdmin(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/revoke-admin`, { id: id });
  }

  setAsAdmin(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/set-user-as-admin`, { id: id });
  }

  forceUpdatePassowrd(id: string): Observable<void> {
    return this.http.patch<void>(`${this.apiUrl}/force-update-password`, { id: id });
  }
}
